<script>
import ListView from '@/components/common/ListView'
import HiveBotDetail from '@/components/hives/HiveBotDetail'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'HiveBotList',

  data() {
    return {
      title: 'Hive Bots',
      searchAttributes: ['hive_type', 'hexId', 'hive_name', 'hive_description'],
      selectedHiveBot: null
    }
  },

  watch: {
    selectedHiveBot() {
      this.routeEdit()
    }
  },

  methods: {
    routeEdit: function() {
      if (this.selectedHiveBot) {
        this.$router
          .replace({
            name: 'hive-bot-detail',
            params: { hiveBotHexId: this.selectedHiveBot.hexId }
          })
          .catch()
      } else {
        this.$router.replace({ name: 'hive-bot-list' }).catch()
      }
    },

    create() {
      this.$router
        .push({
          name: 'hive-bot-register',
          params: { hexId: this.$router.currentRoute.params.hiveHexId }
        })
        .catch()
    }
  },

  computed: {
    ...mapState({
      hiveBots: state => state.hives.hiveBots
    }),
    ...mapGetters({
      can: 'can'
    })
  },

  created() {
    this.$store
      .dispatch('fetchHiveBots', this.$router.currentRoute.params.hiveHexId)
      .then(hiveBots => {
        if (this.$router.currentRoute.name === 'hive-bot-detail') {
          this.selectedHiveBot = hiveBots.find(hiveBot => {
            return (
              hiveBot.hexId === this.$router.currentRoute.params.hiveBotHexId
            )
          }, this)
        }
      }, this)
  },

  components: {
    ListView,
    HiveBotDetail
  }
}
</script>

<template>
  <list-view
    search
    :items="hiveBots"
    :title="title"
    :searchAttributes="searchAttributes"
    item-key="hexId"
    :createAction="true"
    @create="create"
    v-model="selectedHiveBot"
    :updating="updating"
  >
    <template slot="list-item" slot-scope="props">
      <v-list-tile-avatar>
        <vue-letter-avatar
          :name="props.item.className"
          size="40"
          :rounded="true"
        ></vue-letter-avatar>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-text="props.item.className"></v-list-tile-title>
      </v-list-tile-content>
    </template>

    <hive-bot-detail
      slot="list-item-detail"
      slot-scope="props"
      v-if="props.item != null"
      :hive-bot="props.item"
    ></hive-bot-detail>
  </list-view>
</template>
